<template>
  <div id="app">
    <!-- <meta name="X-MAGO-TRANSFERS-MODE" content="airport_remote_transfer" />
    <meta
      name="X-MAGO-TENANT-ID"
      content="2C7719B6-3984-476F-8AB1-B92C17EE88F5"
    />
    <meta
      name="X-MAGO-TENANT-PLATFORM"
      content="http://stn.test.transfers.maginfrastructure.com"
    /> -->
    <search-widget />
  </div>
</template>

<script>
import SearchWidget from "./components/SearchWidget/SearchWidget.vue";

export default {
  name: "App",
  components: {
    SearchWidget
  }
};
</script>

<style>
#app {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
</style>
